import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { Images } from "@assets/images";

type CouponSuccessModalProps = {
  message: string;
};

function CouponSuccessModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<CouponSuccessModalProps>) {
  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="p-6 w-[354px] flex flex-col justify-center items-center">
        <div className="mr-8">
          <img
            className="size-[120px]"
            src={Images.SurpriseBox.default}
            alt=""
          />
        </div>
        <div className="mt-6 text-[#424E62] font-[SVN-Gilroy] font-medium text-center">
          {portalData?.message}
        </div>
      </div>
    </Modal>
  );
}

export default CouponSuccessModal;
